import { Api } from '@src/services/interface';
import { Api as UserHomeApi } from '@src/services/userHomeApi';
import { Api as CommentApi } from '@src/services/commentApi';
import { ARTICLE_API_URL, TALK_API_URL, USER_HOME_API_URL, COMMENT_API_URL, VOTE_POST_SURVEY_API_URL } from '@src/constants';

export const newApi = new Api({
    baseUrl: ARTICLE_API_URL,
});

export const userHomeApi = new UserHomeApi({ baseUrl: USER_HOME_API_URL });

export const talkApi = new UserHomeApi({
    baseUrl: TALK_API_URL,
});

export const commentApi = new CommentApi({ baseUrl: COMMENT_API_URL });

export const voteApi = new UserHomeApi({ baseUrl: VOTE_POST_SURVEY_API_URL });

/**
 * 获取URL查询参数
 * @param url string
 * @param key string
 */
export const getQuery = (url: string, key: string) => {
    let value = '';

    try {
        const urlObj = new URL(url);
        const { searchParams } = urlObj;

        if (searchParams.has(key)) {
            value = searchParams.get(key) || '';
        }
    } catch (e) {
        console.error(e);
    }

    return value;
};

/**
 * 格式化秒
 * @param result
 */

export const formatSecond = (result: number | string) => {
    const resultFormat = Number(result);

    if (!resultFormat && resultFormat !== 0) return result;
    const h = Math.floor((resultFormat / 3600) % 24) || 0;
    const m = Math.floor((resultFormat / 60) % 60) || 0;
    const s = Math.floor(resultFormat % 60) || 0;
    const sTime = s && s.toString().length > 1 ? s : `0${s}`;
    const mTime = m && m.toString().length > 1 ? m : `0${m}`;
    const hTime = h && h.toString().length > 1 ? h : `0${h}`;
    const timeString = h > 0 ? `${hTime}:${mTime}:${sTime}` : `${mTime}:${sTime}`;

    return timeString;
};

/**
 * 数字过万处理
 * @param num
 */

export const moreTenThousand = (num: number | string) => {
    if (!num) return num;

    const numData = Number(num);

    return numData > 9999 ? `${Math.floor(numData / 1000) / 10}万` : num;
};

/**
 * 倒计时
 * @param timesData
 */
export const countTimes = (timesData: string) => {
    const dateEnd = new Date(timesData.replace(/-/g, '/')); //将-转化为/，使用new Date
    const dateNow = new Date(); //获取当前时间
    const dateDiff = dateEnd.getTime() - dateNow.getTime(); //时间差的毫秒数
    const dayDiff = Math.floor(dateDiff / 1000 / 60 / 60 / 24); //计算出相差天数
    const hours = Math.floor((dateDiff / 1000 / 60 / 60) % 24); //计算出小时数
    const minutes = Math.floor((dateDiff / 1000 / 60) % 60); //计算相差分钟数
    let timesString = '';

    if (hours !== 0) {
        timesString = `${hours + 24 * dayDiff}小时`;
    } else {
        timesString = `${minutes}分钟`;
    }

    return timesString;
};

/**
 * 获取年月日时分
 * @param timestamp
 */
export const getYMDHM = (timestamp: number) => {
    const time = new Date(timestamp);
    const year = time.getFullYear();
    let month: number | string = time.getMonth() + 1;
    let date: number | string = time.getDate();
    let hours: number | string = time.getHours();
    let minute: number | string = time.getMinutes();
    let second: number | string = time.getSeconds();

    if (month < 10) {
        month = `0${month}`;
    }
    if (date < 10) {
        date = `0${date}`;
    }
    if (hours < 10) {
        hours = `0${hours}`;
    }
    if (minute < 10) {
        minute = `0${minute}`;
    }
    if (second < 10) {
        second = `0${second}`;
    }

    return {
        year,
        month,
        date,
        hours,
        minute,
    };
};

/**
 * 页面跳转
 * jumpPageUrl('article', id)
 * jumpPageUrl('personal', guid)
 * jumpPageUrl('topic', topicId)
 */
export const jumpPageUrl = (type: string, id: string | number) => {
    const liveUrl = location.href.split('?')?.[0] || '';
    const urlSplit = liveUrl.split('/') || [];

    urlSplit.pop();
    urlSplit.pop();
    const hostUrl = urlSplit.join('/');

    setTimeout(() => {
        location.href = `${hostUrl}/${type}/${id}`;
    }, 300);
};

/**
 * 页面跳转
 * jumpPageUrl('article', id)
 * jumpPageUrl('personal', guid)
 * jumpPageUrl('topic', topicId)
 */
export const weixinIosVideoInit = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isIphone = userAgent.includes('iphone');
    const isWeixin = userAgent.includes('micromessenger');

    if (isIphone && isWeixin) {
        document.addEventListener(
            'WeixinJSBridgeReady',
            () => {
                const timer = setInterval(() => {
                    const videoDom = document.querySelector('video');

                    if (videoDom) {
                        videoDom.play();
                        videoDom.pause();
                        clearInterval(timer);
                    }
                }, 100);
            },
            false,
        );
    }
};

export const formatDate = (timer: string) => {
    const timestamp = new Date(timer).valueOf();
    const nowTimer = new Date().valueOf();
    const difference = (nowTimer - timestamp) / 1000;
    const hours = Math.trunc(difference / 3600);
    const minutes = hours > 0 ? Math.trunc((difference - 3600 * hours) / 60) : Math.trunc(difference / 60);

    if (!hours && minutes <= 1) {
        return '刚刚';
    } else if (!hours && minutes <= 59) {
        return `${minutes}分钟前`;
    } else if (hours >= 1 && hours < 24) {
        return `${hours}小时前`;
    } else if (hours >= 24 && hours < 48) {
        return '1天前';
    } else if (hours >= 48 && hours < 72) {
        return '2天前';
    } else {
        return timer.split(' ')[0];
    }
};

const isfastmode = () => {
    return (() => {
        let isfastmodeNum = 1;

        try {
            localStorage.setItem('checkfastmode', '1' );
            isfastmodeNum = 0;
        } catch (e) {
            console.error(e);
        }

        return isfastmodeNum;
    })();
};

export const setLocalStorage = (key: string, value: any) => {
    if (isfastmode()) return '';
    localStorage.setItem(key, JSON.stringify(value));
};

export const getLocalStorage = (key: string) => {
    if (isfastmode()) return '';
    // @ts-ignore
    return JSON.parse(localStorage.getItem(key));
};

